// auth.ts

import users from "./users.json";

interface User {
  username: string;
  password: string;
  viewer: string;
  isAuthenticated?: boolean;
}

let currentUser: User | null = null;

const authVersion = "1";

const storedVersion = localStorage.getItem("auth_version");
if (storedVersion !== authVersion) {
  localStorage.removeItem("currentUser");
  localStorage.setItem("auth_version", authVersion);
}

export function login(
  username: string,
  password: string,
  viewer: string
): void {
  const user = users.users.find(
    (user: User) => user.username === username && user.password === password
  );

  if (user && user.viewer === viewer) {
    user.isAuthenticated = true;
    delete (user as { password?: string }).password;
    currentUser = user;
    localStorage.setItem("currentUser", JSON.stringify(currentUser));
    localStorage.setItem("auth_version", authVersion);
  } else {
    currentUser = null;
  }
}

export function logout(): void {
  currentUser = null;
  localStorage.removeItem("currentUser");
}

export function getCurrentUser(): User | null {
  if (!currentUser) {
    const storedUser = localStorage.getItem("currentUser");
    const storedVersion = localStorage.getItem("auth_version");
    if (storedUser && storedVersion === authVersion) {
      currentUser = JSON.parse(storedUser);
    } else {
      logout();
      localStorage.setItem("auth_version", authVersion);
    }
  }
  return currentUser;
}

export function updateAuthVersion(newVersion: string): void {
  logout();
  localStorage.setItem("auth_version", newVersion);
}
